import React, {Fragment, useEffect, useState} from 'react';
import {Empty, Spin} from "antd";
import {Column} from "@ant-design/charts";
import {LoadingOutlined} from "@ant-design/icons";
import {Content, LoadingWrapper, Root, Title, TitleWrapper} from "./styled";
import {useDashboardContext} from "contexts/DashboardProvider";
import {colors} from "utils/colors";


const config = {
  data: [],
  xField: 'month_year',
  yField: 'total',
  shapeField: 'column25D',
  axis: {
    y: { labelFormatter: '~s' },
  },
  style: {
    fill: `linear-gradient(-70deg, ${colors.green[300]} 0%, ${colors.green[500]} 80%)`,
  },
  tooltip: {
    title: 'month_year',
    items: ['Amount'],
  },
  legend: false,
};

const ExpensesChart = () => {

  const { state } = useDashboardContext()

  const [configData, setConfigData] = useState(config)

  useEffect(() => {
    setConfigData((prevState) => ({
      ...prevState,
      data: state.chart_expenses
    }))
  }, [state.chart_expenses])

  return (
    <Root>
      <TitleWrapper>
        <Title>Monthly Expenses</Title>
      </TitleWrapper>
      <Content>
        {state.is_loading_chart_expenses
          ? (
            <LoadingWrapper>
              <Spin indicator={<LoadingOutlined spin />} size={"large"} />
              <div>Fetching data ...</div>
            </LoadingWrapper>
          ) : (
            <Fragment>
              {state.chart_expenses.length === 0
                ? <Empty description="No Data Available" />
                : <Column {...configData} />
              }
            </Fragment>
          )
        }
      </Content>
    </Root>
  )
}

export default ExpensesChart;
